import { Component, ViewChild, ElementRef } from '@angular/core';
import { Clipboard } from '@ionic-native/clipboard';
import * as $ from 'jquery'

@Component({
  selector: 'rmt-clipboard',
  templateUrl: 'rmt-clipboard.html'
})
export class RmtClipboardComponent {
  @ViewChild('content', { read: ElementRef }) content;
  @ViewChild('copy', { read: ElementRef }) copy;
  mouseTimeout = null;
  hideTimeout = null;
  doubleClickTimeout = null;
  scroll = null;

  static currentClipboard = null;
  
  constructor(private clipboard: Clipboard) {
  }

  ngAfterViewInit() {
    const node = this.copy.nativeElement;
    const scrolls = $(node).parents('.scroll-content');
    if (scrolls && scrolls.length > 0)
      this.scroll = scrolls[0];

    if (node.parentNode)
      node.parentNode.removeChild(node);

    this.content.nativeElement.ontouchstart = () => {
      this.mouseDown();
    };
    this.content.nativeElement.ontouchend = (ev) => {
      if (ev.cancelable){
        ev.stopPropagation();
        ev.preventDefault(); 
      }
      this.mouseUp();
    };
    this.content.nativeElement.oncontextmenu = (ev) => {
      if (ev.cancelable){
        ev.stopPropagation();
        ev.preventDefault(); 
      }
      this.showCopy();
    }
  }

  copyTo() {
    this.clipboard.copy(this.content.nativeElement.innerText);
  }

  showCopy() {
    if (!this.scroll)
      return;

    if (RmtClipboardComponent.currentClipboard && RmtClipboardComponent.currentClipboard !== this)
      RmtClipboardComponent.currentClipboard.hideCopy();
    RmtClipboardComponent.currentClipboard = this;
    if (this.hideTimeout)
      window.clearTimeout(this.hideTimeout);
    this.hideTimeout = null;

    const node = this.copy.nativeElement;
    if (node.parentNode)
      node.parentNode.removeChild(node);
    
    this.scroll.appendChild(node);
    node.style.opacity = 1.0;    
    let top = 0;
    let left = 0;
    let el = this.content.nativeElement;
    while (el && el !== this.scroll) {
      top += el.offsetTop;
      left += el.offsetLeft;
      el = el.offsetParent;
    }
    node.style.top = (top - this.content.nativeElement.offsetHeight - 15) + 'px';
    node.style.left = (left + this.content.nativeElement.offsetWidth/2 - 50) + 'px';

    const onclick = document.body.onclick;
    document.body.onclick = (ev) => {
      this.hideCopy();
      if (onclick)
        onclick.call(document.body, ev);
    }
  }

  hideCopy() {
    RmtClipboardComponent.currentClipboard = null;
    this.copy.nativeElement.style.opacity = 0.0;
    this.hideTimeout = window.setTimeout(() => {
      if (this.copy.nativeElement.parentNode === this.scroll)
        this.scroll.removeChild(this.copy.nativeElement);
    }, 200);
  }

  mouseDown() {
    if (this.mouseTimeout)
      window.clearTimeout(this.mouseTimeout);
    this.mouseTimeout = window.setTimeout(() => {
      this.showCopy();
      this.mouseTimeout = null;
    }, 1000);
    if (this.doubleClickTimeout)
      this.showCopy();
    this.doubleClickTimeout = window.setTimeout(() => {
      this.doubleClickTimeout = null;
    }, 800);
  }

  mouseUp() {    
    if (this.mouseTimeout)
      window.clearTimeout(this.mouseTimeout);
    this.mouseTimeout = null;
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-clipboard/rmt-clipboard.ts